import { render, staticRenderFns } from "./ProductsInStockLocationsInternal.vue?vue&type=template&id=07b28ae7&scoped=true"
import script from "./ProductsInStockLocationsInternal.vue?vue&type=script&lang=js"
export * from "./ProductsInStockLocationsInternal.vue?vue&type=script&lang=js"
import style0 from "./ProductsInStockLocationsInternal.vue?vue&type=style&index=0&id=07b28ae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b28ae7",
  null
  
)

export default component.exports